(function () {
    'use strict';

    function ready(fn) {
        if (document.readyState !== 'loading') { fn(); } else { document.addEventListener('DOMContentLoaded', fn); }
    }

    /* ---------- Save 收藏切换 ---------- */
    ready(function () {
        document.querySelectorAll('[data-hd-save]').forEach(function (btn) {
            btn.addEventListener('click', function () {
                var active = btn.classList.toggle('is-active');
                var label = btn.querySelector('[data-save-label]');
                if (label) { label.textContent = active ? 'Saved' : 'Save'; }
                btn.setAttribute('aria-pressed', active ? 'true' : 'false');
            });
        });
    });

    /* ---------- Share 复制链接 ---------- */
    ready(function () {
        document.querySelectorAll('[data-hd-share]').forEach(function (btn) {
            btn.addEventListener('click', function () {
                var url = window.location.href;
                var done = function () { flash(btn, 'Link copied'); };
                if (navigator.clipboard && window.isSecureContext) {
                    navigator.clipboard.writeText(url).then(done).catch(function () { fallback(url); });
                } else { fallback(url); }
            });
        });

        function fallback(text) {
            var ta = document.createElement('textarea');
            ta.value = text;
            ta.style.position = 'fixed';
            ta.style.opacity = '0';
            document.body.appendChild(ta);
            ta.select();
            try { document.execCommand('copy'); } catch (e) { /* noop */ }
            document.body.removeChild(ta);
        }

        function flash(btn, msg) {
            var old = btn.querySelector('[data-save-label]');
            var text = old ? old.textContent : btn.textContent.trim();
            var span = document.createElement('span');
            span.textContent = msg;
            span.style.fontWeight = '600';
            if (old) { old.textContent = msg; } else { btn.textContent = msg; }
            window.setTimeout(function () {
                if (old) { old.textContent = text; } else { btn.textContent = text; }
            }, 1600);
        }
    });

    /* ---------- 相册灯箱 ---------- */
    ready(function () {
        var cells = document.querySelectorAll('.hotel-album-cell img');
        var cells = document.querySelectorAll('.hotel-album-cell[data-src], .hd-room-album-slide[data-src]');
        var lb = document.getElementById('hdLightbox');
        if (!lb) { return; }
        var img = lb.querySelector('img');
        var close = lb.querySelector('.hd-lightbox-close');

        function open(src, alt) {
            img.src = src;
            img.alt = alt || '';
            lb.classList.add('is-open');
            document.body.style.overflow = 'hidden';
        }
        function closeBox() {
            lb.classList.remove('is-open');
            img.removeAttribute('src');
            document.body.style.overflow = '';
        }

        cells.forEach(function (cell) {
            cell.addEventListener('click', function () {
                var src = cell.getAttribute('src');
                var alt = cell.getAttribute('alt');
                // 灯箱用更高清晰度版本（去掉 widths 限制）
                var lgSrc = src.replace(/width=\d+(&|$)/, '');
                open(lgSrc || src, alt);
            });
        });
        close.addEventListener('click', closeBox);
        lb.addEventListener('click', function (e) { if (e.target === lb) { closeBox(); } });
        document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeBox(); } });
    });

    /* ---------- 地图锚点：滚动到 Google/Bing 地图（演示） ---------- */
    ready(function () {
        document.querySelectorAll('[data-hd-map]').forEach(function (btn) {
            btn.addEventListener('click', function () {
                var q = encodeURIComponent(btn.getAttribute('data-hd-map'));
                window.open('https://www.google.com/maps/search/?api=1&query=' + q, '_blank', 'noopener');
            });
        });
    });

    /* ---------- 房型列表：房型相册轮播（修改 1.1） ---------- */
    ready(function () {
        document.querySelectorAll('[data-hd-room-album]').forEach(function (album) {
            var track = album.querySelector('.hd-room-album-track');
            var slides = album.querySelectorAll('.hd-room-album-slide');
            if (!track || !slides.length) { return; }

            var index = 0;

            function go(step) {
                index = (index + step + slides.length) % slides.length;
                track.style.transform = 'translateX(' + (-index * 100) + '%)';
            }

            album.querySelectorAll('.hd-room-album-nav').forEach(function (btn) {
                btn.addEventListener('click', function () {
                    go(Number(btn.getAttribute('data-step')));
                });
            });

            var count = album.querySelector('.hd-room-album-count');
            if (count) {
                count.addEventListener('click', function () {
                    var current = slides[index];
                    if (current) { current.click(); }
                });
            }
        });
    });

    /* ---------- 房型列表：变体滑轨箭头（修改 1.1） ---------- */
    ready(function () {
        document.querySelectorAll('.hd-room-rails').forEach(function (rail) {
            var viewport = rail.querySelector('.hd-room-rail');
            var arrows = rail.querySelectorAll('.hd-room-rail-arrow');
            if (!viewport || !arrows.length) { return; }

            function stepWidth() {
                var first = viewport.querySelector('.hd-room-rate');
                return first ? first.getBoundingClientRect().width : viewport.clientWidth;
            }

            function sync() {
                var max = viewport.scrollWidth - viewport.clientWidth;
                var scrollable = max > 1;
                arrows.forEach(function (btn) {
                    var dir = Number(btn.getAttribute('data-step'));
                    btn.hidden = !scrollable;
                    btn.disabled = !scrollable || (dir < 0 ? viewport.scrollLeft <= 1 : viewport.scrollLeft >= max - 1);
                });
            }

            arrows.forEach(function (btn) {
                btn.addEventListener('click', function () {
                    viewport.scrollBy({ left: Number(btn.getAttribute('data-step')) * stepWidth(), behavior: 'smooth' });
                });
            });

            viewport.addEventListener('scroll', sync, { passive: true });
            window.addEventListener('resize', sync);
            sync();
        });
    });
})();
